module.exports = __webpack_public_path__ + "static/media/fillilingMachine.7eb60f84.webp";